export const translation = {
  app: {
    title: "Kematechnik Innomontage | FSM",
  },
  page: {
    login: {
      title: "Bejelentkezés",
      infos: {
        block: {
          title: "Kematechnik-Innomontage Kft. FSM alkalmazás",
          p1: "Az alkalmazást a KI-Group alkalmazottjai jogosultak használni Microsoftos authentikációt követően.",
          p2: "További információ:",
          office: "Iroda",
          customerservice: "Ügyfélszolgálat",
        },
      },
    },
    welcome: {
      title: "Kezdőlap",
      description:
        "Üdvözöljük a Kematechnik Innomontage FSM alkalmazás felületén!",
      welcome: "Kedves {name}!",
    },
    templates: {
      title: "Sablonok",
      label: {
        deletetemplate: {
          title: "Sablon törlése",
          question: 'Törlöd a "{name}" nevű sablont?',
        },
        copytemplate: {
          title: "Sablon másolása",
          description:
            'Adja meg, hogy a "{name}" nevű sablon másolata milyen néven jöjjön létre!',
          defaultvalue: "[Másolat] {name}",
        },
      },
      button: {
        newtemplate: "Új sablon",
        copytemplate: "Másol",
        deletetemplate: "Töröl",
        edittemplate: "Szerkeszt",
      },
      exception: {
        listtemplate: {
          title: "Sikertelen a sablonok listázása",
          description: "Ismeretlen hiba!",
        },
        copytemplate: {
          title: "Sikertelen a sablon másolása",
          description:
            'Sikertelen a "{name}" névvel sablon másolat létrehozása!',
        },
        delete: {
          title: "Sikertelen törlés",
          description: 'A "{name}" nevű sablon törlése sikertelen!',
        },
      },
      success: {
        copytemplate: 'Sikeres a "{name}" névvel sablon másolat létrehozása!',
        delete: 'Sikeres a "{name}" nevű sablon törlése!',
      },
    },
    newtemplate: {
      title: "Új sablon",
      success: {
        createtemplate: "Sikeres az új sablon létrehozása!",
      },
    },
    edittemplate: {
      button: {
        addField: "Új mező",
        save: "Mentés",
        saveasdraft: "Mentés piszkozatként",
      },
      exception: {
        create: {
          title: "Sikertelen a sablon mentés",
          description: "Ismeretlen hiba!",
        },
        update: {
          title: "Sikertelen a sablon szerkesztése",
          description: "Ismeretlen hiba!",
        },
      },
      success: {
        update: "Sikeres a sablon szerkesztése!",
      },
    },
    serviceworksheets: {
      title: "Szerviz munkalapok",
      button: {
        newserviceworksheet: "Új munka",
        deleteserviceworksheet: "Törlés",
        editserviceworksheets: "Szerkesztés",
      },
      label: {
        deleteserviceworksheet: {
          title: "Szerviz munkalap törlése",
          question:
            'Törlöd a "{salesOrderNumber}" értékesítési rendeléshez tartozó szerviz munkalapot?',
        },
        onsiteservice: "helyszíni szerviz",
      },
      exception: {
        listserviceworksheets: {
          title: "Sikertelen a szerviz munkalapok listázása",
          description: "Ismeretlen hiba!",
        },
        loadtemplate: {
          title: "Sikertelen a sablonok betöltése",
          description: "Ismeretlen hiba!",
        },
        loadusers: {
          title: "Sikertelen a dolgozók betöltése",
          description: "Ismeretlen hiba!",
        },
        delete: {
          title: "Sikertelen törlés",
          description:
            'Sikertelen a "{salesOrderNumber}" értékesítési rendeléshez tartozó szerviz munkalap törlése!',
        },
        FAILED_DELETE_MS_CALENDAR_EVENT: {
          title: "A szerviz munkalap törlése sikeres",
          description:
            "A szerviz munkalap törlése sikere. A szerviz munkalaphoz tartozó Microsoft naptári esemény törlése sikertelen!",
        },
      },
      success: {
        delete:
          'Sikeres a "{salesOrderNumber}" értékesítési rendeléshez tartozó szerviz munkalap törlése!',
      },
    },
    newserviceworksheet: {
      title: "Új szerviz munkalap",
      button: {
        create: "Létrehozás",
      },
      exception: {
        create: {
          title: "Sikertelen a szerviz munkalap létrehozása",
          description: "Ismeretlen hiba!",
        },
      },
      success: {
        create: "Sikeres a szerviz munkalap létrehozása!",
      },
    },
    editserviceworksheet: {
      accordion: {
        items: "Cikkek",
      },
      modal: {
        schedulesquestion: {
          title: "A dolgozó elfoglalt",
          question:
            "A felsorolt dolgozóknak az alábbi elfoglaltságok szerepelnek a naptárjaikban. Rögzíti a szerviz feladatot?",
        },
        workersupdate: {
          title: "Mai munka módosítása",
          question:
            "Biztos benne, hogy a mai napra kiosztott szerviz munkánál módosítja a szerviz technikusokat?",
        },
        closeserviceworksheet: {
          title: "Szerviz munkalap zárása",
          question: "Biztos benne, hogy a szerviz munkalapot lezárja?",
        },
      },
      warning: {
        templateisrequired:
          "Szervíz munkához kötelező legalább egy sablont kiválasztani!",
      },
      exception: {
        load: {
          title: "Sikertelen a szerviz munkalap megjelenítése",
          description: "Ismeretlen hiba!",
        },
        update: {
          title: "Sikertelen a szerviz munkalap módosítása",
          description: "Ismeretlen hiba!",
        },
        loadtemplate: {
          title: "Sikertelen a sablonok betöltése",
          description: "Ismeretlen hiba!",
        },
        loaduser: {
          title: "Sikertelen a szerviz munkások betöltése",
          description: "Ismeretlen hiba!",
        },
        reloadsalesorder: {
          title: "Sikertelen az eladási rendelés frissítése",
          description: "Ismeretlen hiba!",
        },
        FAILED_NOT_UPDATEABILITY_SERVICE_WORKSHEET: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description:
            "A szerviz munkalap státusza nem teszi lehetővé a szerkesztést!",
        },
        FAILED_UPDATE_TO_NEW_STATUS: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description: "Invalid státuszba kerülne a szerkesztést követően!",
        },
        FAILED_UPDATE_NEW_DATE_IS_NOT_FUTURE_DATE: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description:
            "Az új dátum nem jövőbeli dátum! (Csak jövőbeli dátumra lehet szerviz munkalapot létrehozni!)",
        },
        FAILED_UPDATE_NEW_DATE_IS_NOT_VALID_PERIOD: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description: "A megadott intervallum nem valid intervallum!",
        },
        FAILED_UPDATE_BECAUSE_ORIGINAL_SERVICE_WORKSHEET_NOT_TODAY_OR_LATER: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description:
            "A szerviz munkalap dátuma nem holnapi vagy későbbi, ezért nem szerkeszthető",
        },
        FAILED_UPDATE_BECAUSE_UPDATED_SERVICE_WORKSHEET_NOT_NULL_OR_FEATUER: {
          title: "Sikertelen a szerviz munkalap szerkesztése",
          description:
            "A megadott dátum nem valid! (A dátum üres vagy jövőbeli időpont lehet!)",
        },
        FAILED_MS_CALENDAR_SYNC: {
          title: "Sikertelen a szerviz dolgozók naptárjának szinkronja",
          description:
            "A szerviz munkalap mentése sikeres, a szerviz dolgozók naptárjának szinkronja sikertelen!",
        },
        downloadpdf: {
          title: "Sikertelen a pdf letöltése",
          description: "A szerviz munkalap Pdf letöltése sikertelen!",
        },
        downloadimage: {
          title: "Sikertelen a kép letöltése",
          description:
            "A szerviz munkalaphoz tartozó kép letöltése sikertelen!",
        },
        closeserviceworksheet: {
          title: "Sikertelen a szerviz munkalap zárása",
          description: "A szerviz munkalap zárása sikertelen!",
        },
      },
      success: {
        update: "Sikeres a szerviz munkalap módosítása!",
        reloadsalesorder: "Sikeres az eladási rendelés frissítése!",
        closeserviceworksheet: "A munkalap zárása sikeres!",
      },
      button: {
        reloadsalesorder: "Eladási rendelés frissítése",
        save: "Mentés",
        modifyWorker: "Szerviztechnikusok módosítása",
        close: "Lezár",
      },
    },
    onsiteserviceworksheets: {
      title: "Várakozó munkalapok",
      form: {
        customer: {
          null: "Válassz ügyfelet!",
        },
      },
      exception: {
        listserviceworksheets: {
          title: "Sikertelen művelet",
          description: "Sikertelen a várakozó munkalapok listázása!",
        },
        getserviceworksheet: {
          title: "Sikertelen művelet",
          description:
            "Sikertelen a kiválasztott munkalapok részleteinek megjelenítése!",
        },
        listcustomers: {
          title: "Sikertelen művelet",
          description: "Sikertelen az ügyfelek betöltése!",
        },
        missingcustomer: {
          title: "Az ügyfelet kötelező megadni!",
        },
        confirm: {
          title: "Sikertelen művelet",
          description: "Sikertelen a szervíz munkalap jóváhagyása!",
        },
      },
      button: {
        confirm: "Jóváhagy",
      },
    },
    servicehistory: {
      title: "szerviz történet",
      exception: {
        listhistory: {
          title: "Szerviz történet listázása",
          description: "Sikertelen a szerviz történet listázása!",
        },
      },
    },
    emails: {
      title: "E-mail-ek",
      label: {
        email: "E-mail",
      },
      buttons: {
        showemail: "E-mail megjelenítése",
      },
      exception: {
        listemails: {
          title: "E-mailek listázása",
          description: "Sikertelen az e-mailek listázása!",
        },
        loadattachment: {
          title: "E-mail csatolmányok letöltése",
          description: "Sikertelen az e-mailek csatolmányok letöltése!",
        },
        loadbodyattachment:
          "Sikertelen az e-mail törzsében a csatolmányok betöltése!",
      },
    },
    apps: {
      title: "Mobil appok",
      label: {
        deletetapp: {
          title: "Applikáció törlése",
          question:
            "Törlöd a {name} felhasználóhoz tartozó {key} kulcsú regisztrációt?",
        },
        registration: {
          title: "Alkalmazás regisztrálása",
          description:
            "Alkalmazás regisztrálása a kiválasztott felhasználó számára",
        },
      },
      button: {
        delete: "Törlés",
        create: "Regisztrál",
        cancel: "Mégsem",
      },
      success: {
        delete:
          "Sikeresen törlted a {name} felhasználóhoz tartozó {key} kulcsú regisztrációt!",
        registration: 'Sikeres aplikáció regisztrálása "{key}" kulcssal',
      },
      exception: {
        listapps: {
          title: "Sikertelen a mobil regisztrációk listázása",
          description: "Ismeretlen hiba!",
        },
        delete: {
          description:
            "Sikertelena {name} felhasználóhoz tartozó {key} kulcsú regisztrációt törlése!",
        },
        loadusers: {
          title: "Sikertelen a dolgozók betöltése",
          description: "Ismeretlen hiba!",
        },
        registration: {
          title: "Sikertelen az aplikáció regisztrálása",
          description: "Ismeretlen hiba!",
        },
      },
    },
    scheduledjobs: {
      title: "Todok",
      button: {
        startJob: "Folyamat elindítása",
        stopJob: "Folyamat leállítása",
        runJob: "Folyamat kényszerített futtatása",
        showLog: "Logok",
      },
      label: {
        emptyloglist: "Nincsennek mentett logok!",
      },
      exception: {
        listjobs: {
          title: "Sikertelen a todo feladatok listázása",
          description: "Ismeretlen hiba!",
        },
        startJob: {
          title: "Sikertelen a todo feladat elindítása",
          description: "Ismeretlen hiba!",
        },
        stopJob: {
          title: "Sikertelen a todo feladatok leállítása",
          description: "Ismeretlen hiba!",
        },
        runJob: {
          title: "Sikertelen a todo feladatok kényszerített futtatása",
          description: "Ismeretlen hiba!",
        },
      },
      success: {
        startJob: "Sikeres a todo feladat elindítása!",
        stopJob: "Sikeres a todo feladatok leállítása!",
        runJob: "Sikeres a todo feladatok kényszerített futtatása!",
      },
    },
    alarms: {
      title: "Állapotok",
      success: {
        email: {
          run: "Sikeres az e-mail küldés futtatása",
        },
        servicewworksheet: {
          run: "Sikeres a szerviz munkalapok feldolgozásának futtatása",
        },
        onsiteservicewworksheet: {
          run: "Sikeres a helyszíni szerviz munkalapok feldolgozásának futtatása",
        },
      },
      exception: {
        email: {
          notactive: {
            title: "Sikertelen az e-mail küldés futtatása",
            description: "Az e-mail küldés feladat nem aktív!",
          },
          notok: {
            title: "Sikertelen az e-mail küldés futtatása",
            description:
              "Az e-mail küldés feladat végrehajtása korábbi futás során bekövetkezett hiba miatt nem engedett!",
          },
          run: {
            title: "Sikertelen az e-mail küldés futtatása",
            description: "Ismeretlen hiba: sikertelen a feladat végrehajtása!",
          },
        },
        servicewworksheet: {
          notactive: {
            title: "Sikertelen a szerviz munkalapok feldolgozásának futtatása",
            description: "A szerviz munkalapok feldolgozása nem aktív!",
          },
          notok: {
            title: "Sikertelen a szerviz munkalapok feldolgozásának futtatása",
            description:
              "A szerviz munkalapok feldolgozása feladat végrehajtása korábbi futás során bekövetkezett hiba miatt nem engedett!",
          },
          run: {
            title: "Sikertelen a szerviz munkalapok feldolgozásának futtatása",
            description: "Ismeretlen hiba: sikertelen a feladat végrehajtása!",
          },
        },
        onsiteservicewworksheet: {
          notactive: {
            title:
              "Sikertelen a helyszíni szerviz munkalapok feldolgozásának futtatása",
            description:
              "A helyszíni szerviz munkalapok feldolgozása nem aktív!",
          },
          notok: {
            title:
              "Sikertelen a helyszíni szerviz munkalapok feldolgozásának futtatása",
            description:
              "A helyszíni szerviz munkalapok feldolgozása feladat végrehajtása korábbi futás során bekövetkezett hiba miatt nem engedett!",
          },
          run: {
            title:
              "Sikertelen a helyszíni szerviz munkalapok feldolgozásának futtatása",
            description: "Ismeretlen hiba: sikertelen a feladat végrehajtása!",
          },
        },
      },
    },
    notfound: {
      title: "404",
      description: "A keresett oldal nem található!",
    },
  },
  component: {
    common: {
      footer: {
        copyright1: "2024. Copyright - Kematechnik-Innomontage Kft.",
        copyright2: "Minden jog fenntartva",
        version: " (verzió: {version})",
      },
      loading: {
        loading: "Feldolgozás...",
      },
      modal: {
        button: {
          ok: "Oké",
          cancel: "Mégsem",
          no: "Nem",
          yes: "Igen",
        },
        login: {
          title: "Belépés szükséges",
          description: "Az oldal megtekintéséhez jelentkezzél be!",
        },
      },
    },
  },
  data: {
    template: {
      data: {
        name: "Név",
        status: {
          label: "Státusz",
          value: {
            active: "Aktív",
            deleted: "Törölt",
            draft: "Piszkozat",
          },
        },
        version: "Verzió",
        createdUser: "Létrehozta",
        createdDate: "Létrehozva",
        fieldoptions: "Válasz opciók",
      },
      form: {
        name: {
          label: "Sablon neve",
          placeholder: "Sablon neve",
        },
        machineservice: "Gép szerviz (géptípus/gyáriszám/üzemóra mezők)",
        status: {
          value: {
            all: "Mindegyik",
            active: "Aktív",
            deleted: "Törölt",
            draft: "Piszkozat",
          },
        },
        field: {
          name: {
            placeholder: "Szerviz lépés neve",
          },
          worksheetTitle: {
            placeholder: "Szerviz munkalapon (pdf) lépés címe",
          },
          description: {
            placeholder: "Szerviz lépés leírása",
          },
          required: "Kötelező",
          photos: "Fotó(k)",
          text: "Egysoros szöveg",
        },
      },
      warning: {
        notfoundtemplates: "Nincs találat!",
      },
      exception: {
        listTemplate: "Sikertelen a sablonok listázása",
      },
    },
    serviceworksheet: {
      data: {
        salesordernumber: "Eladási rendelés no.",
        date: "Dátum",
        status: {
          label: "Státusz",
          sync: "szinkronizált",
          value: {
            ALL: "mindegyik",
            DRAFT: "piszkozat",
            ALLOCATED: "kiosztott",
            UPLOADED: "Feltöltött",
            DONE: "kész",
            CLOSED: "lezárt",
            DELETED: "törölt",
          },
        },
        partner: "Ügyfél",
      },
      form: {
        salesorder: {
          number: {
            label: "Eladási rendelés száma",
            placeholder: "Eladási rendelés száma",
          },
          customer: "Ügyfél",
          ship: "Munkavégzés helye",
          contact: "Kapcsolattartó",
          item: {
            number: "Azonosító",
            description: "Leírás",
            quantity: "Tervezett mennyiség",
            usedquantity: "Felhasznált mennyiség",
          },
        },
        status: {
          label: "Állapot",
          value: {
            DRAFT: "Piszkozat",
            ALLOCATED: "Kiosztott",
            UPLOADED: "Feltöltött",
            DONE: "Kész",
            CLOSED: "Lezárt",
            DELETED: "Törölt",
          },
        },
        note: {
          label: "Jegyzetek",
          placeholder: "Jegyzetek",
        },
        templates: {
          label: "Sablon(ok)",
          value: {
            null: "-- Válasz sablont --",
          },
        },
        primaryworker: {
          label: "Fő szerviztechnikus",
          value: {
            null: "-- Válasz fő szerviztechnikust --",
          },
        },
        workers: {
          label: "További szerviztechnikusok",
          value: {
            null: "Válasz szerviztechnikus(ok)at...",
          },
          emptyLabel: "Nincs választható szerviztechnikus",
        },
        date: {
          label: "Dátum",
          value: {
            FULL_DAY: "Teljes nap",
            PERIOD: "Pontos időszak",
          },
        },
        templatenameandversion: "{name} (verzió: {version})",
        templatename: "Szerviz munka",
        created: "Létrehozva",
        modify: "Módosítva",
        pdf: "Szerviz munkalap (pdf)",
        emailstatus: {
          label: "E-mail státusz",
          value: {
            NEW: "új (elküldésre vár)",
            SENDED: "Elküldött",
            EXCEPTION: "Sikertelen e-mail küldés",
            MISSING_TO: "Nincs címzett",
          },
        },
        machineNumber: "Gyáriszám",
        serviceWorksheetNo: "Szerviz munkalap száma",
      },
      warning: {
        notfoundserviceworksheet: "Nincs találat!",
      },
      exception: {
        listServiceWorksheet: "Sikertelen a szerviz munkalapok listázása",
      },
    },
    onsiteserviceworksheet: {
      data: {
        customer: "Ügyfél",
        createdTime: "Feltöltés ideje",
        updateTime: "Utolsó módosítás",
        updateUser: "Módosító",
        user: "Szerviz technikus",
        signature: {
          label: "Aláírás",
          name: "Név",
          tel: "Tel",
          email: "E-mail",
        },
        time: "Kitöltés ideje",
        template: {
          name: "Szerviz munka",
        },
        machineNumber: "Gyáriszám",
        machineOperatingHours: "Üzemóra",
        machineType: "Gép típus",
        note: "Megjegyzés",
        outing: "Kiszállás (alkalmak)",
        workTime: "Kiszállás (alkalmak)",
        workType: {
          label: "Munkavégzés jellege",
          value: {
            toBeBilled: "Számlázandó",
            notToBeBilled: "Nem számlázandó",
            underWarranty: "Garanciális",
          },
        },
        status: {
          label: "Státusz",
          value: {
            ALL: "Összes",
            UPLOADED: "Feltöltött",
            PROCESSED: "Feldolgozható",
            DONE: "Feldolgozott",
          },
        },
        attachedFile: "Csatolt fényképek: {count} db",
      },
    },
    servicehistory: {
      table: {
        client: "ügyfél",
        machinedata: "Gép",
        template: {
          label: "Sablon",
          value: "{name} (verzió: {version})",
        },
        serviceworksheetno: "Szerviz munkalap",
        salesorderno: "Eladási rendelés",
        date: "Dátum",
        details: "Részletek",
      },
      detail: {
        serviceWorksheetNo: "Szerviz munka száma",
        pdf: "Szerviz munka PDF",
        shortpdf: "rövid verzió",
        clientName: "Megrendelő",
        salesOrderNo: "Eladási rendelés száma",
        workPlace: "Munkavégzés helye",
        workDate: "Munkavégzés ideje",
        primaryWorker: "Fő szerviztechnikus",
        workers: "További szeviztechnikusok",
        machineNumber: "Gyáriszám",
        machineType: "Gép típus",
        machineOperatingHours: "Üzemóra",
        note: "Észrevétel",
      },
      warning: {
        notfoundservicehistory: "Nincs találat!",
      },
      exception: {
        listServiceHistory: "Sikertelen a szerviz történet listázása",
        getServiceHistory: "Sikertelen a betöltés!",
      },
    },
    emails: {
      form: {
        to: "Címzett",
        cc: "Másolat",
        subject: "Tárgy",
        date: "Dátum",
        content: "Törzs",
        attachments: "Csatolmányok",
        status: {
          label: "Státusz",
          value: {
            ALL: "Összes",
            NEW: "új",
            SENDED: "elküldött",
            EXCEPTION: "hiba",
          },
        },
      },
      warning: {
        notfoundemails: "Nem találhatóak e-mailek!",
      },
      exception: {
        listemails: "Sikertelen az e-mailek listázása!",
      },
    },
    apps: {
      form: {
        workers: {
          value: {
            null: "Válasz szerviztechnikust...",
          },
        },
      },
      data: {
        key: "kulcs",
        user: "felhasználó",
        creator: "létrehozta",
        created: "létrehozva",
        lastSync: "utolsó sync",
      },
      warning: {
        notfoundapps: "Nincs regisztrált alkalmazás!",
      },
      exception: {
        listApps: "Sikertelen a mobil applikációk listázása!",
      },
    },
    scheduledjobs: {
      data: {
        id: {
          label: "Id",
        },
        className: {
          label: "Class name",
        },
        active: {
          label: "Státusz",
          value: {
            active: "Aktív",
            inactive: "Inaktív",
          },
          currentstatus: {
            EXCEPTION: "hiba",
            STOP: "leállítva",
            RUNNING: "fut",
            ACTIVE: "aktív",
          },
        },
        lastRunning: {
          label: "Utolsó futás",
        },
        timing: {
          label: "Időzítés",
        },
        status: {
          label: "Státusz",
        },
      },
      warning: {
        notfoundjobs: "Nincs találat!",
      },
    },
    scheduledjoblogs: {
      data: {
        status: {
          label: "Státusz",
          value: {
            ERROR: "hiba",
            WARNING: "figyelmeztetés",
            INFO: "info",
          },
        },
        date: "Dátum",
        msg: "üzenet",
      },
    },
    alarm: {
      button: {
        refresh: "Frissítés",
      },
      label: {
        onSiteServiceWorksheet: {
          label: "Várakozó helyszíni szerviz munkalapok:",
          withcount: "Várakozó helyszíni szerviz munkalapok: {count} db",
          button: "Feldolgozás ({count} db)",
        },
        notApproveonSiteServiceWorksheetTask: {
          label: "Jóváhagyandó helyszíni szerviz munkalapok:",
          withcount: "Jóváhagyandó helyszíni szerviz munkalapok: {count} db",
          button: "Jóváhagyás ({count} db)",
        },
        servicewWorksheet: {
          label: "Várakozó szerviz munkalapok:",
          withcount: "Várakozó szerviz munkalapok: {count} db",
          button: "Feldolgozás ({count} db)",
        },
        email: {
          label: "Várakozó e-mailek:",
          withcount: "Várakozó e-mailek: {count} db",
          button: "Kikülés ({count} db)",
        },
      },
    },
  },
  button: {
    search: "Keresés",
    login: "Belépés",
    logout: "Kilépés",
  },
  label: {
    successoperation: "Sikeres művelet",
  },
};
